<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">上传视频</div>
    </div>
    <div class="page-body">
      <div class="videoDiv" @click="goToVideo">
        <div class="message" v-if="!selectedVideoUrl">请选择视频</div>

        <div class="videoDivTime" v-if="this.selectedVideoUrl">
          {{ formattedTime }}
        </div>

        <img
          src="@/assets/aiVideo/sybf.png"
          alt="#"
          class="bodyTop-sybf"
          v-if="this.selectedVideoUrl"
        />

        <img :src="spfm1" alt="#" class="video" v-if="spfm1" />
      </div>
    </div>
    <div class="bottom">
      <div class="bottomBtn" @click="showModal = true">选择视频</div>
      <div class="bottomBtn" @click="uploadVideo">上传</div>
    </div>
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">视频要求</div>
        <div class="modal-body">
          <div class="modal-text">视频类型：竖屏</div>
          <div class="modal-text">视频时长：最少30秒</div>
          <div class="modal-text">
            视频字幕：<span style="color: #ff4500">勿上传带字幕的视频</span>
          </div>
          <div class="modal-text">视频背景：干净整洁</div>
        </div>
        <div class="modal-confirm-div">
          <div @click="handleConfirm" class="modal-confirm-btn">我知道了</div>
        </div>
      </div>
    </div>
    <FullScreenVideo
      :src="videoSrc"
      @error="handleVideoError"
      @goBack="goBack"
      v-if="showVideo"
    />
    <input
      ref="videoInput"
      type="file"
      accept="video/*"
      style="display: none"
      @change="handleVideoSelect"
    />
    <!-- <loadingVue v-model="isLoading" text="文件上传中..." /> -->
  </div>
</template>

<script>
import { Toast } from "vant";
// import loadingVue from "@/components/loadingVue.vue";
import { extractVideoFrame, blobUrlToFile } from "@/utils/videoUtils";
import FullScreenVideo from "@/components/fullScreenVideo.vue";
import { voUpload, voDelete, uploadCoverImage } from "@/api";
import uploadFileInChunks from "@/utils/uploadFileInChunks";
export default {
  name: "recordingGuide",
  // loadingVue,
  components: { FullScreenVideo },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.spTime / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.spTime % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  data() {
    return {
      showModal: false,
      selectedFile: null,
      selectedVideoUrl: null, // 用于预览
      // isLoading: false,
      spfm1: "",
      pageFile: "",
      videoSrc: "",
      showVideo: false,
      spTime: "",
      progress: 0,
      coverImg: null,
	  currentPlatform: '',
    };
  },
  mounted() {
    this.showModal = true;
	document.title = "上传视频";
	this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
  },
  methods: {
    goToVideo() {
      this.showVideo = true;
      this.videoSrc = this.selectedVideoUrl;
    },
    // 返回按钮逻辑
    onBack() {
      this.$router.back();
    },
    goBack() {
      this.showVideo = false;
    },
    handleVideoError(error) {
      console.log(error);
    },
    //点击上传视频
    uploadVideo() {
      this.uploadFileNew(this.pageFile);
      // this.uploadFile(this.pageFile);
    },
    // 点击“我知道了”
    handleConfirm() {
      this.closeModal(); // 先关闭弹窗
      // 触发隐藏 input 的点击
      this.$refs.videoInput.click();
    },
    // 处理选中的视频
    async handleVideoSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 检查是否为视频
      if (!file.type.startsWith("video/")) {
        this.$toast && this.$toast("请选择视频文件");
        return;
      }

      // 检查时长（需用 video 元素加载后才能获取）
      this.checkVideoDuration(file);

      // 生成预览 URL
      this.selectedVideoUrl = URL.createObjectURL(file);
      this.coverImg = null;
      //   spfm1
      try {
        const poster = await extractVideoFrame(this.selectedVideoUrl, 1, {
          maxWidth: 300,
        });

        const isBlackPoster = await this.isImageMostlyBlack(poster);
        this.spfm1 = poster;

        if (isBlackPoster) {
          this.coverImg = null;
        } else {
          const file = await blobUrlToFile(poster, "video_cover.jpg");
          this.coverImg = file;
        }
      } catch (error) {
        this.coverImg = null;
        this.$toast && this.$toast("生成封面失败:" + error.message);
      }
      this.selectedFile = file;
    },

    async isImageMostlyBlack(imageUrl) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            const w = Math.min(img.width || 1, 200);
            const h = Math.min(img.height || 1, 200);
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            const data = ctx.getImageData(0, 0, w, h).data;

            let total = 0;
            const count = data.length / 4;
            for (let i = 0; i < data.length; i += 4) {
              total += (data[i] + data[i + 1] + data[i + 2]) / 3;
            }
            const avgBrightness = total / count;
            resolve(avgBrightness <= 15);
          } catch (e) {
            resolve(false);
          }
        };
        img.onerror = () => resolve(false);
        img.src = imageUrl;
      });
    },

    // 检查视频时长（异步）
    checkVideoDuration(file) {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        const duration = video.duration; // 单位：秒
        if (duration < 30) {
          this.$toast && this.$toast("视频时长不可少于30秒！");

          this.resetSelection();
        } else {
          this.spTime = String(duration).split(".")[0];
          //   this.uploadFile(file);
          this.pageFile = file;
        }
      };
      video.onerror = () => {
        this.$toast && this.$toast("无法读取视频信息");

        this.resetSelection();
      };
      video.src = URL.createObjectURL(file);
    },
    async uploadFileNew(file) {
      if (!file) {
        return this.$toast && this.$toast("请选择视频！");
      }
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0, // 持续显示，直到关闭
      });
      try {
        const result = await uploadFileInChunks(file, {
          chunkSize: 5 * 1024 * 1024, // 5MB
          concurrent: 3, // 3 个并发
          maxRetry: 3,
          voType: "1",
          spot: "1",
          spTime: this.spTime,
          onProgress: (percent, count, total) => {
            this.progress = percent;
            console.log(`进度: ${percent}%, 已完成: ${count}/${total}`);
          },
        });
        Toast.clear();
        console.log(result, "result");
        if (this.coverImg) {
          console.log("人工上传封面");
          const formData = new FormData();
          formData.append("firstImageFile", this.coverImg);
          formData.append("fileId", result.fileId);
          await uploadCoverImage(formData);
        }
        // this.isLoading = false;
        this.$router.replace({ path: "customAvatar" });
      } catch (err) {
        Toast.clear();

        console.error(err);
        // errorMsg.value = `上传失败: ${err.message}`;
      } finally {
        console.log("result11");

        Toast.clear();
      }
    },
    // 上传视频（示例）
    async uploadFile(file) {
      if (!file) {
        return this.$toast && this.$toast("请选择视频！");
      }
      // this.isLoading = true;
      const formData = new FormData();
      formData.append("audioFile", file);
      formData.append("voType", "1");
      formData.append("spot", "1");
      let data = await voUpload(formData);
      if (data) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0, // 持续显示，直到关闭
        });
        const response = await fetch(data.fileUrl, {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": data.fileType,
          },
          body: file,
        });

        if (response.ok) {
          Toast.clear();
          // this.isLoading = false;
          this.$router.replace({ path: "customAvatar" });
        } else {
          await voDelete(data.fileId);
          Toast.clear();
          this.$toast && this.$toast("上传失败，请重试");
        }
      }
    },
    // 重置选择
    resetSelection() {
      this.selectedFile = null;
      this.selectedVideoUrl = null;
      // 清空 input 值，确保下次能触发 change
      this.$refs.videoInput.value = "";
    },
    // 关闭弹窗（点击阴影或主动调用）
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  /* overflow-y: auto; */
  padding: 5.333vw 4.2666vw 0 4.2666vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.bodayFirst {
  margin: 3.2vw 1.066vw 0 2.666vw;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-bottom: 5.333vw;
}
.bodayFirstImg {
  width: 38.4vw;
  height: 42.666vw;
}
.bodayFirstTitle {
  width: 45.066vw;
  line-height: 4.4vw;
  font-family: SourceHanSansSC-regular;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.9333vw;
  margin-top: 1.2vw;
}
.bodayFirstTitle > div:nth-child(2) {
  margin-top: 2.666vw;
}
.bodayFirstTitle > div:nth-child(3) {
  margin-top: 5.666vw;
}
.bodayFirstTitle > div:nth-child(4) {
  margin-top: 2.666vw;
}
.bodySecond {
  padding: 3.2vw 5.333vw 5.333vw 5.333vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.bodySecondItem {
  /* background-color: red;dis */
  display: flex;
  align-items: center;
  flex-direction: column;
}
.bodySecondImg {
  width: 18.666vw;
  height: 20vw;
}
.bodySecondTitle {
  margin-top: 3.466vw;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.933vw;
  line-height: 4vw;
}
.bodyThird {
  width: 86.133vw;
  height: 42.666vw;
  margin-left: 2.666vw;
  margin-top: 3.2vw;
}
.bottonBtn {
  margin: 10.666vw 0 7.6vw 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  width: 29.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  line-height: 8vw;
  font-size: 3.2vw;
  text-align: center;
}
.bottonBtnOne {
  margin-right: 3.2vw;

  background-color: #ebebed;
  font-weight: 500;
  color: #666666;
  opacity: 0.8;
}
.bottonBtnTwo {
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  height: 58.666vw;
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-text {
  min-width: 44.8vw;
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  text-align: center;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  margin-top: 5.4666vw;
}
.videoDiv {
  position: relative;
  width: 85.333vw;
  height: calc(100vh - 44vw);
  height: calc(100dvh - 44vw);
  border-radius: 4.2666vw;
  background-color: #d8d8d8;
  box-shadow: 0px 0px 1.0666vw 0px rgba(0, 0, 0, 0.1);
}
.message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video {
  width: 100%;
  height: 100%;
  border-radius: 4.2666vw;
  object-fit: cover;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 8vw;
}
.bottomBtn {
  width: 40.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  line-height: 8vw;
}
.bodyTop-sybf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8vw;
  height: 8vw;
}
.videoDivTime {
  position: absolute;
  bottom: 5.0666vw;
  left: 10vw;
  height: 7.8666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 5.333vw;
  text-align: left;
}
</style>
